import Popup from '../popup'

export default class RecaptchaPopup extends Popup {
	static title = 'recaptcha-popup'

	init() {
		super.init()

		this.eventEmitter.on('newsletter:submit', obj => {
			this.formElement = obj.formElement
			this.open()
		})

		this.recaptchaInterval = setInterval(() => {
			if (grecaptcha && grecaptcha.getResponse().length !== 0 && this.formElement) {
				this.formElement.submit()
				clearInterval(this.recaptchaInterval)
			}
		}, 1000)
	}

	open() {
		super.open()
	}
}
